import { WishlistService } from '../services/wishlist.service'

export function loadWishlist() {    
    return async dispatch => {
        const products = await WishlistService.loadWishlist()
        dispatch({ type: 'SET_WISHLIST', products })
    }
}

export function updateWishlist(product, qiuckAdd, quant) {    
    return async dispatch => {
        const updatedProduct = await WishlistService.addToWishlist(product, qiuckAdd, quant)
        dispatch({ type: 'UPDATE_WISHLIST', updatedProduct })
    }
}

export function removeFromWishlist(product) {
    return async dispatch => {
        const removedProduct = await WishlistService.removeFromWishlist(product)
        dispatch({ type: 'REMOVE_WISHLIST', removedProduct })
    }
}

